// Your web app's Firebase configuration

// For Firebase JS SDK v7.20.0 and later, measurementId is optional

// # TO DO: remove mock and add .env configurations 

// export default {
//   apiKey: process.env.APIKEY,
//   authDomain: process.env.AUTHDOMAIN,
//   projectId: process.env.PROJECTID,
//   storageBucket: process.env.STORAGEBUCKET,
//   messagingSenderId: process.env.MESSAGINGSENDERID,
//   appId: process.env.APPID,
//   databaseUrl: process.env.DATABASEURL
// };

export default {
  apiKey: "AIzaSyDH3ogmdqKJFDEazG9R7h3mFOLSIybq3SU",
  authDomain: "psicologia-6d3e3.firebaseapp.com",
  databaseURL: "https://psicologia-6d3e3.firebaseio.com",
  projectId: "psicologia-6d3e3",
  storageBucket: "psicologia-6d3e3.appspot.com",
  messagingSenderId: "565396675453",
  appId: "1:565396675453:web:2400066c2cabbfff3a4a14",
  measurementId: "G-X44RE639NP"
};